import DownloadIcon from '@mui/icons-material/Download';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useSelector } from 'react-redux';
import ModalV2 from '/@/components/bayer/modal-v2';
import Slider from '/@/components/slider';
import { getWeedPDF } from '/@/hooks/weeds/apiProviders';
import { _ } from '/@/locale';
import { getAppInstance } from '/@/store/session/selectors';

const WeedModal = ({ weed, open, handleClose }) => {
    const appInstance = useSelector(getAppInstance);
    const handleDownloadClick = () => {
        getWeedPDF({ weedId: weed.id, appInstanceId: appInstance.id });
    };
    const weedDetails = [
        { label: _('Familia'), value: _(weed.family) },
        { label: _('Ciclo'), value: _(weed.cycle) },
        { label: _('Tamaño'), value: _(weed.sizeDescription) },
        { label: _('Tipo'), value: _(weed.type) },
        { label: _('Estación'), value: _(weed.weatherSeasons[0]) },
        { label: _('Fruto / Flores'), value: _(weed.flowerFruitDescription) },
        { label: _('Hojas'), value: _(weed.leavesDescription) },
        { label: _('Tallo / Raíces'), value: _(weed.rootStemDescription) },
    ];
    return (
        <ModalV2
            open={open}
            onClose={handleClose}
            title={_('Maleza')}
            bodyProps={{ alignItems: 'stretch', sx: { textAlign: 'left' } }}
            actionsProps={{ sx: { justifyContent: 'flex-end' } }}
            actions={
                <Button variant='contained' color='secondary' onClick={handleDownloadClick}>
                    <Grid2 container spacing={1} justifyContent='center' alignItems='center'>
                        <Grid2 container>
                            <DownloadIcon />
                        </Grid2>
                        <Grid2>{_('Descargar')}</Grid2>
                    </Grid2>
                </Button>
            }
        >
            <Stack padding={2}>
                {!!weed.images.length && (
                    <Grid container justifyContent={'center'}>
                        <Grid item>
                            <Slider images={weed.images} />
                        </Grid>
                    </Grid>
                )}

                <Box sx={{ mt: 2 }}>
                    <Typography color='primary' variant='h6'>
                        {_(weed.name)}
                    </Typography>
                    <Typography color='primary' variant='body2' sx={{ fontStyle: 'italic' }}>
                        {weed.scientificName}
                    </Typography>
                </Box>
                <Grid container spacing={1} sx={{ m: 0.5, width: 'fit-content' }}>
                    {weedDetails.map((detail, index) => (
                        <Grid item xs={6} key={index}>
                            <Typography color='primary' variant='body2' sx={{ fontWeight: 600 }}>
                                {detail.label}
                            </Typography>
                            <Typography color='primary.mui.inactive' variant='body2'>
                                {detail.value}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Stack>
        </ModalV2>
    );
};

export default WeedModal;
